// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3CNor","topBottomGutter":"Layout_topBottomGutter__2oWwm"};